export default __webpack_public_path__ + "static/media/Kerry-Donahue.c5fe9cc9.jpg";